import React from 'react';

import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';

import { ApiReclamationLitigePiece } from 'types/apiReturns';


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';

import Datetime from 'components/Shared/Datetime';
import theme from 'theme';

type Props = {
  pieces: ApiReclamationLitigePiece[];
};

export default function ReclamationLitigePieces({ pieces } : Props) {
  
  // Tri des pièces pour afficher d'abord celles avec anomalie
  const piecesSorted = [...pieces].sort((a, b) => {
    // Les pièces avec anomalie sont placées en premier
    if (a.anomalie && !b.anomalie) return -1;
    if (!a.anomalie && b.anomalie) return 1;
    return 0;
  });

  return (

    <TableContainer sx={{ background: '#FAFAFA', maxHeight: '100%', pb:8 }}>
      <Table>
        <TableHead> 
          <TableRow>
            <TableCell sx={{ backgroundColor: '' }}>Numéro pièce</TableCell>
            <TableCell sx={{ backgroundColor: '' }}>Numéro préparation</TableCell>
            <TableCell sx={{ backgroundColor: '' }}>Référence commande</TableCell>
            <TableCell sx={{ backgroundColor: '' }}>Montant HT</TableCell>
            <TableCell sx={{ backgroundColor: '' }}>Preneur d'ordre</TableCell>
            <TableCell sx={{ backgroundColor: '' }}>Dépôt départ</TableCell>
            <TableCell sx={{ backgroundColor: '' }}>Nb articles</TableCell>
            <TableCell sx={{ backgroundColor: '' }}>Transporteur</TableCell>
            <TableCell sx={{ backgroundColor: '' }}>Nb dossiers</TableCell>
            <TableCell sx={{ backgroundColor: '' }}>Expédition</TableCell>
            <TableCell sx={{ backgroundColor: '' }}>Création</TableCell>
          </TableRow>
        </TableHead>      
        <TableBody>
          {piecesSorted.map((piece, index) => (
              <TableRow key={index} sx={{ backgroundColor: piece.anomalie ? theme.palette.secondary.main : null}}>
                <TableCell>

                  <Link
                      to={`/informations/${piece.numeroPiece}`}
                      underline="hover"
                      component={RouterLink}
                      sx={{ fontWeight: 'bold' }}
                  >
                      {piece.numeroPiece}
                  </Link>

                </TableCell>
                <TableCell>{piece.numeroPreparation}</TableCell>
                <TableCell>{piece.referenceCommande}</TableCell>
                <TableCell>{piece.caPiece!.toFixed(2)}</TableCell>
                <TableCell>{piece.codePO}</TableCell>
                <TableCell>{piece.depotDepart}</TableCell>
                <TableCell>{piece.nbLignesArticle}</TableCell>
                <TableCell>{piece.transporteur}</TableCell>
                <TableCell>{piece.nbDossierHorsLitige}</TableCell>
                <TableCell><Datetime datetime={piece.dateExpedition} /></TableCell>
                <TableCell><Datetime datetime={piece.dateCreation} /></TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}